// assets/variant-selects-qty-fix.js
(() => {
  // capture=true で先に拾って止める（Dawnのvariant-selectsに届く前）
  document.addEventListener(
    "change",
    (e) => {
      const el = e.target;
      if (!(el instanceof Element)) return;

      //  variant-selects の中にある quantity の select だけ弾く
      if (el.matches("variant-selects select[name='quantity']")) {
        e.stopImmediatePropagation();
        // stopPropagation だけだと届くケースがあるので immediate を推奨
      }
    },
    true
  );
})();
